"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var shared_1 = require("../../../../../shared");
var TableComponentBase_1 = require("../TableComponentBase");
var CellValue_meta_1 = require("./CellValue.meta");
var ksys_app_template_1 = require("@kurtosys/ksys-app-template");
var Translate_1 = __importDefault(require("../../../Translate"));
var CellValue = /** @class */ (function (_super) {
    __extends(CellValue, _super);
    function CellValue(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = CellValue_meta_1.CELL_VALUE_CATEGORY_KEY;
        _this.componentKey = CellValue_meta_1.CELL_VALUE_COMPONENT_KEY;
        return _this;
    }
    Object.defineProperty(CellValue.prototype, "parentComponentKey", {
        get: function () {
            return CellValue_meta_1.CELL_VALUE_PARENT_COMPONENT_KEY;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellValue.prototype, "tableEventsKey", {
        get: function () {
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    CellValue.prototype.render = function () {
        var _a = this.props, column = _a.column, cellValue = _a.cellValue;
        var arraySeparator = column.arraySeparator;
        if (!ksys_app_template_1.utils.typeChecks.isUndefined(arraySeparator) && ksys_app_template_1.utils.isArrayLike.isArrayLike(cellValue)) {
            return (react_1.default.createElement(react_1.Fragment, null, cellValue.map(function (subValue, subIndex) {
                return (react_1.default.createElement(react_1.Fragment, { key: subIndex + "_" + subValue },
                    subIndex > 0 && react_1.default.createElement("span", null, arraySeparator),
                    react_1.default.createElement(Translate_1.default, null, subValue)));
            })));
        }
        return (react_1.default.createElement(Translate_1.default, null, cellValue));
    };
    CellValue = __decorate([
        mobx_react_1.observer
    ], CellValue);
    return CellValue;
}(TableComponentBase_1.TableComponentBase));
exports.CellValue = CellValue;
exports.default = shared_1.InjectedStyledComponent(CellValue, CellValue_meta_1.CELL_VALUE_CATEGORY_KEY, CellValue_meta_1.CELL_VALUE_PARENT_COMPONENT_KEY, [CellValue_meta_1.CELL_VALUE_COMPONENT_KEY]);
